import React from 'react';

const Section$ = () => <div style={{textIndent: '2em'}}>
    <div style={{textAlign: 'center'}}>
        <br/>
        <h1 name="0-6" className="point" id="0-6">第七章 生产管理制度</h1></div>
    <div style={{textIndent: '2em'}}>
        <br/>

        <h2 name="0-6-0" className="point" id="0-6-0">一、通用条款</h2>
        <h4 name="0-6-0-0" className="point" id="0-6-0-0">1、车间物业管理细则</h4>
        <p>（设备、工具、叉车、场地及除维修业务、质量检验、人员安排之外的其他事项）</p>
        <h4>责任单位：独立核算单位车间物业管理科</h4>
        <h4 name="0-6-0-0-0" className="point" id="0-6-0-0-0">1.1设备</h4>
        <h4 name="0-6-0-0-0-0" className="point" id="0-6-0-0-0-0">1.1.1设备需求</h4>
        <p>1、需求提报：维修公司负责人、车间物业管理科负责人。</p>
        <p>2、需求汇总：独立核算单位负责人根据金额大小对应权限逐级审批。</p>
        <p>3、设备采购：遵循第十一章《生产物资采购细则》。</p>
        <h4 name="0-6-0-0-0-1" className="point" id="0-6-0-0-0-1">1.1.2设备使用规范</h4>
        <p>车间场地、设备、专用工具的使用者是维修公司的工作人员，但其管理权归车间的物业管理科。车间物业管理科的责任是保证车间场地、设备、叉车、专用工具等设施的整洁完善，所以车间物业管理科有权制定如下使用规范。维修公司全体员工遵照执行。</p>
        <h4>1、设备使用</h4>
        <p>操作人在使用设备前，需先检查设备外观是否有破损，电源线是否有破损、漏电风险；确认无异常后，先开机试运行，观察运转时是否有异常噪音出现。确认无异常后，可以进入设备的正常使用范围。设备使用完毕后，需及时清洁并断电。</p>
        <p>考核标准：每项考核50分。</p>
        <p><strong>2、定期检查、维护</strong>（车间物业管理科每月20日执行，每项考核50分。）</p>
        <p>2.1 电器部位检查：检查外观是否破损，电源线是否破损、老化存在漏电、短路的风险，</p>
        <p>2.2 机械部位检查：检查工作移动部件是否有外观磕碰变形、旋转部件周围是否有异物存在。</p>
        <p>2.3 液压部位检查：检查工作液部件的油管外观是否出现老化、开裂现象，明显漏油现象。</p>
        <p>2.4 仪表部位检查：检查仪表在开机状态下的初始状态是否显示为零或者标准电压、电流的范围。</p>
        <p>3、设备报废:设备报废由车间物业管理科提报，总监确认，资产管理部审核、备案。</p>
        <p>由资产管理部制定设备报废申报表。</p>
        <h4 name="0-6-0-0-0-2" className="point" id="0-6-0-0-0-2">1.1.3设备管理及维护制度</h4>
        <p>设备操作工在独立使用设备前，必须掌握该设备的操作技能；</p>
        <p>1、设备使用应定人定机，对公用设备由专人负责保养；</p>
        <p>2、操作工要养成自觉爱护设备的习惯。班前班后认真擦拭设备及注油润滑工作，使设备经常保持良好的润滑与清洁。</p>
        <p>3、操作工要遵守设备操作规程，合理使用设备，并管理好设备附件；</p>
        <p>4、对私自操作设备人员，要进行严厉的批评教育，并由此发生的一切后果由私自操作者负责；</p>
        <p>5、设备管理员应该根据设备维护要求及时设备技术状况制定设备和测量装置的保养细则、保养周期和检定日期；</p>
        <p>6、设备保养人应严格按照常规维修设备保养周期进行保养、并做好记录交设备管理员验收；</p>
        <p>7、设备发生故障应及时停机，使用部门应立即通知设备管理员或单位领导，请修理人员检查排除故障；当修理人员在排除故障时，操作人员应积极协助修理人员排除故障；</p>
        <p>8、对设备使用年限较长，零部件损坏严重且又无法修复和没有改造价值的，可办理报废手续报经理批准后执行；</p>
        <p>9、对设备的检查、保养、维修应做好所有的记录，由设备员归档以便检查；</p>
        <h4 name="0-6-0-0-1" className="point" id="0-6-0-0-1">1.2工具</h4>
        <h4>工具分为人手工具、分队工具、通用工具、专用工具。</h4>
        <h4 name="0-6-0-0-1-0" className="point" id="0-6-0-0-1-0">1.2.1人手工具</h4>
        <p>1、登记表（数量、种类、图片、押金）</p>
        <p>2、归属权</p>
        <p>人手工具归属权为公司，使用管理权为个人。每个人需支付一定金额的押金以确保工具的完好使用（押金从第一个月工资中扣除），有个别丢失或损坏需个人原价购买。个人离开公司时需原样退回，由车间物业管理科检验合格后再退还押金。</p>
        <p>如发现工具不全或有破损却继续作业，考核当事人50分。因为人手工具的原因导致维修质量事故，造成了损失，考核100-500分。损失严重者，另议。</p>
        <h4 name="0-6-0-0-1-1" className="point" id="0-6-0-0-1-1">1.2.2分队工具</h4>
        <p>1、登记表（数量、种类、图片）</p>
        <p>2、归属权</p>
        <p>2.1若是独立核算单元，归属权归分队所有，责任人为分队长，根据情况可直接或分期向公司购买，标准由公司提供，工具需完好方可作业。</p>
        <p>2.2若是现有维修公司班组，归属权归公司所有，管理使用权归班组，责任人为班组长。班组长负责分队工具的完好，车间物业管理公司定期检查，只有工具完好方可作业。</p>
        <p>如发现工具不全或有破损却继续作业，因为分队工具的原因导致维修质量事故，造成了损失，每人考核100-500分。损失严重者，另议。</p>
        <h4 name="0-6-0-0-1-2" className="point" id="0-6-0-0-1-2">1.2.3通用工具</h4>
        <h4>（如扭力扳手、千斤顶、风炮、气动工具、电动工具、手动吊具、量具、刃具、拉拔器、绳具、重型套筒等）</h4>
        <p>1、登记表（数量、种类、图片）</p>
        <p>2、归属权</p>
        <p>通用工具归属权归公司，管理责任归车间物业管理科，使用权归维修公司。</p>
        <p>车间物业管理科负责通用工具的完好以及正确操作规范的监督，如出现通用工具丢失或非正常使用的损坏，考核车间物业管理科100分/件，价值贵重者，另议。车间物业管理科可对通用工具的使用者实行考核，如发现不按规范操作者，考核100分/次，价值贵重者，另议。如有通用工具借出丢失，责任人需原价赔偿。</p>
        <h4 name="0-6-0-0-1-3" className="point" id="0-6-0-0-1-3">1.2.4专用工具</h4>
        <p>1、登记表（数量、种类、图片）</p>
        <p>2、归属权</p>
        <p>专用工具的归属权归公司，管理责任归车间物业管理科，使用权归维修公司。专用工具需封闭管理，专用工具带出车间时必须有出入票据。</p>
        <p>车间物业管理科负责专用工具的完好以及正确操作规范的监督，如出现专用工具丢失或非正常使用的损坏，考核车间物业管理科200分/件，价值贵重者，另议。车间物业管理科可对专用工具的使用者实行考核，如发现不按规范操作者，考核200分/次，价值贵重者，另议。如有专用工具借出丢失，责任人需原价赔偿。</p>
        <h4 name="0-6-0-0-2" className="point" id="0-6-0-0-2">1.3叉车</h4>
        <p>1、登记表（数量、种类、图片）</p>
        <p>2、归属权</p>
        <p>叉车的归属权归公司，管理责任归各管理公司的事业部、品牌部及仓储物流部，使用权归持有叉车操作证的人员。</p>
        <p>3、关于场内叉车使用注意事项</p>
        <h4 name="0-6-0-0-2-0" className="point" id="0-6-0-0-2-0">1.3.1检查车辆</h4>
        <p>1. 叉车作业前后，应检查外观，加注燃料、润滑油和冷却水。</p>
        <p>2. 检查起动、运转及制动性能。</p>
        <p>3. 检查灯光、音响信号是否齐全有效。</p>
        <p>4. 叉车运转过程中应检查压力、温度是否正常。</p>
        <p>5. 叉车运行后还应检查外泄漏情况并及时更换密封件。</p>
        <p>6. 电瓶叉车除应检查以上内容外，还应按电瓶车的有关检查内容，对电瓶叉车的电路进行检查。</p>
        <p>7.每月20日对叉车底盘做润滑一次，定期针对车况进行保养。</p>
        <p>考核：操作者必须按要求操作，违反者考核100分/次，情节严重者另议。</p>
        <h4 name="0-6-0-0-2-1" className="point" id="0-6-0-0-2-1">1.3.2起步</h4>
        <p>1. 起步前，观察四周，确认无防碍行车安全的障碍后，先鸣笛后起步。</p>
        <p>2. 气压式制动的车辆，制动气压表读数必须达到规定值方可起步。</p>
        <p>3. 叉车在载物起步时，驾驶员应先确认所载货物平稳可靠。</p>
        <p>4. 起步必须缓慢平稳起步。</p>
        <p>考核：操作者必须按要求操作，违反者考核100分/次，情节严重者另议。</p>
        <h4 name="0-6-0-0-2-2" className="point" id="0-6-0-0-2-2">1.3.3行驶</h4>
        <p>1. 行驶时，货叉底端距地高度应保持300 ~ 400mm， 门架须后倾。</p>
        <p>2. 行驶时不得将货叉升得太高。进出作业现场或行驶途中，要注意上空有无障阻物刮碰。载物行驶时，如货叉升得太高，还会增加叉车总体重心高度，影响叉车的稳定性。</p>
        <p>3. 卸货后应先降落货叉至正常的行驶位置后再行驶。</p>
        <p>4. 转弯时，如附近有行人或车辆，应先出信号，并禁止高速急转弯。高速急转弯会导致车辆失去横向稳定而倾翻。</p>
        <p>5. 内燃叉车在下坡时严禁熄火滑行。</p>
        <p>6. 非特殊情况禁止载物行驶中急刹车。</p>
        <p>7. 载物行驶在超过7°和用高于一档的速度上下坡时，非特殊情况不得使用制动器。</p>
        <p>8. 叉车在运行时要遵守厂内交通规则，必须与前面的车辆保持一定的安全距离。</p>
        <p>9. 叉车运行时，载荷必须处于不防碍行驶的最低位置，门架要适当后倾。除堆垛或装车时，不得升高载荷。在搬运庞大物件时，物件挡住驾驶员的视线，此时应倒开叉车。</p>
        <p>10. 叉车由后轮控制转向，所以必须时刻注意车后的摆幅，避免初学者驾驶时经常出现的转弯过急现象。</p>
        <p>11.禁止在坡道上转弯，也不应横跨坡道行驶。</p>
        <p>12、厂区内车速不得高于每小时5公里。</p>
        <p>考核：操作者若未按要求行使，违反者考核100分/次，情节严重者另议。</p>
        <h4 name="0-6-0-0-2-3" className="point" id="0-6-0-0-2-3">1.3.4装卸</h4>
        <p>1. 叉载物品时，应按需调整两货叉间距，使两叉负荷均衡，不得偏斜，物品的一面应贴靠挡物架，叉载的重量应符合载荷中心曲线标志牌的规定。</p>
        <p>2. 载物高度不得遮挡架驶员的视线。</p>
        <p>3. 在进行物品的装卸过程中，必须用制动器制动叉车。</p>
        <p>4. 货叉在接近或撤离物品时，车速应缓慢平稳，注意车轮不要碾压物品垫木，以免碾压物绷起伤人。</p>
        <p>5. 用货叉叉货时，货叉应尽可能深地叉入载荷下面，还要注意货叉尖不能碰到其它货物或物件。应采用最小的门架后倾来稳定载荷，以免载荷后向后滑动。放下载荷时可使门架少量前倾，以便于安放载荷和抽出货叉。</p>
        <p>6. 禁止高速叉取货物和用叉头向坚硬物体碰撞。</p>
        <p>7. 叉车作业时禁止人员站在叉车上。</p>
        <p>8. 叉车叉物作业时，禁止人员站在货叉周围，以免货物倒塌伤人。</p>
        <p>9. 禁止用货叉举升人员从事高处作业，以免发生高处坠落事故。</p>
        <p>10. 不准用制动惯性溜放物品。</p>
        <p>11. 不准在码头岸边直接叉装船上货物。</p>
        <p>12. 禁止使用单叉作业。</p>
        <p>13. 禁止超载作业。</p>
        <p>考核：操作者必须按要求操作，违反者考核100分/次，情节严重者另议。</p>
        <p>警告：操作者必须持证上岗，无证人员严禁动用，违反者考核100分/次，情节严重者另议。</p>
        <p>以上各项的责任部门为车间物业管理科，车间维修人员需无条件配合工作。</p>
        <h4 name="0-6-0-0-3" className="point" id="0-6-0-0-3">1.4场地</h4>
        <h4 name="0-6-0-0-3-0" className="point" id="0-6-0-0-3-0">1.4.1区域管理</h4>
        <p>1、作业区域要明确划分。5S标准。</p>
        <p>1.1 维修厂内的场地，实行划区分配；按照设备的使用频率、设备尺寸的大小、进行合理划分配。</p>
        <p>1.2 设备、叉车、人手工具、通用工具、专用工具按类别固定区域放置。</p>
        <p>1.3 每个车道定义作业类型，保养类、维修类、钣金类、总成大修类等。</p>
        <p>考核：监察部考核车间物业管理科50分/次，车间物业管理科考核技师50分/次。</p>
        <h4 name="0-6-0-0-3-1" className="point" id="0-6-0-0-3-1">1.4.2标识管理</h4>
        <p>1、危险品运输车辆必须要有安全标识，挂车不能进入厂区，车辆不能进入车间。</p>
        <p>2、所有设备都需要悬挂安全使用标识。</p>
        <p>3、在修车辆都需要悬挂“正在作业”标识及“严禁启动”标识。</p>
        <p>4、所有维修车辆未经保护确认都需要悬挂“严禁驾驶室翻转”、“严禁货箱举升”标识。</p>
        <p>5、各类标识（地面标识、标识牌）都应完好有效。</p>
        <p>考核：监察部考核车间物业管理科100分/次，车间物业管理科考核作业人员100分/次。</p>
        <h4 name="0-6-0-0-3-2" className="point" id="0-6-0-0-3-2">1.4.3环境管理</h4>
        <p>1、每个作业内容，在完成作业任务车辆离开后，首要任务就是清理场地。</p>
        <p>2、场地内要设分类垃圾桶，即油渍类、纸品类、滤芯类。</p>
        <p>3、场地在生产作业时，作业环境必须做到三不落地，即：工具不落地、零件不落地、油液不落地。</p>
        <p>4、不清洁的车辆禁止进入车间和经营场所。</p>
        <p>5、不允许穿着带油污、尘土的工作服以及带油污的手套进入客户车辆的驾驶室。</p>
        <p>6、进入待修车辆时，第一时间要用三件套对司机驾驶室进行保护。</p>
        <p>考核：监察部考核车间物业管理科50分/次，车间物业管理科考核作业人员50分/次。</p>
        <h4 name="0-6-0-0-3-3" className="point" id="0-6-0-0-3-3">1.4.4车间办公室管理</h4>
        <p>严禁车间办公室吸烟、打闹、睡觉、玩手机。</p>
        <p>1、确保车间办公室干净、整洁、无异味。</p>
        <p>2、确定车间办公室环境值日表，明确责任人。</p>
        <p>3、工作服放置在车间办公室指定储物柜中，严禁随意摆放。</p>
        <p>4、严禁在车间办公室乱接用电设备。</p>
        <p>5、严禁在车间办公室临时存放配件、工具等。</p>
        <p>考核：监察部考核车间物业管理科50分/项，车间物业管理科考核车间作业人员50分/项。</p>
        <h4 name="0-6-0-0-3-4" className="point" id="0-6-0-0-3-4">1.4.5职业形象管理</h4>
        <p>1、职业装包括：技师服（工装）、仓储物流工服、销售正装、客服接待正装、冬季/夏季时装、户外装、休闲装、劳保鞋、领带、围脖、帽子、手套、衬衣等。</p>
        <p>2、要求：员工穿着对应岗位的职业装是云豪集团对每一位员工的基本规范之一，员工的职业形象是衡量本人是否是云豪合格员工的基本要素之一。要求上班期间生产岗位人员必须穿着职业装（包括带手套）。</p>
        <p>3、严禁在工作时间闲聊，严禁工作人员与客户瞎聊。</p>
        <p>4、严禁在工作期间吸烟。</p>
        <p>5、严禁在生产场地内吃零食。</p>
        <p>考核：监察部考核车间物业管理科50分/项，车间物业管理科考核车间作业人员50分/项。</p>
        <h4>第五部分 工具领取表</h4>

        <h3 name="0-6-0-1" className="point" id="0-6-0-1">2、车间作业流程细则</h3>
        <h4 name="0-6-0-1-0" className="point" id="0-6-0-1-0">2.1车间作业流程</h4>
        <p>说明：横向数字代表步骤顺序；纵向代表此流程涉及到的岗位；</p>
        <h4 name="0-6-0-1-1" className="point" id="0-6-0-1-1">2.2车间作业流程规范</h4>
        <p>1、客服把接车时填写好的维修工单转交维修公司现场第一负责人，并确认其收到，并告知已经接车完毕，可以进场维修。</p>
        <p>2、现场第一负责人拿着维修工单对看板进行更新，并做已进场标记。</p>
        <p>3、现场第一负责人把车辆开到车间相对应的维修工位。</p>
        <p>4、现场第一负责人将维修工单交给相应的维修技师，并向维修技师交代报修情况。</p>
        <p>5、维修技师把维修所需要用到的工具准备齐全，整齐的摆放在相应维修工位的工具车上。</p>
        <p>6、维修技师拿着领料单到仓库领料窗口领取配件，领取的配件放在维修工位的工具车架子上。</p>
        <p>7、维修技师将维修工单，相应的维修项目打卡开始时间。</p>
        <p>8、维修技师进行维修作业，同时维修公司现场第一负责人对作业人员进行实时巡查管控。</p>
        <p>9、维修技师在作业过程发现有额外需要处理的故障时，将其记录在维修工单上。</p>
        <p>10、维修技师查询额外需要处理的故障所需要的零件，零件号。</p>
        <p>11、维修公司现场第一负责人根据维修技师反馈的额外需要处理的故障，进行检查确认，维修公司现场第一负责人将额外需要处理的故障反馈给客服。</p>
        <p>12、客服接受到需要额外处理的故障，同时维修技师在完成此项目时，对此项目进行自检，检查自己的维修质量，确保车辆维修后故障得到很好的解决。</p>
        <p>13、客服制作额外需要处理故障的报价，同时维修技师对完成的维修项目进行完工打卡。</p>
        <p>14、客服查看零件。</p>
        <p>15、零件库管向客服反馈所需要的零件是否齐全。</p>
        <p>16、客服与客户进行沟通，向客户报价。</p>
        <p>17、客服和客户沟通完，客户接受报价同意进行维修。</p>
        <p>18、客服在维修工单上填写增修内容。</p>
        <p>19、客服把填写好的维修工单转交维修公司现场第一负责人，并告知维修公司现场第一负责人可以进行增修项目的维修工作。</p>
        <p>20、维修公司现场第一负责人拿着维修工单对看板进行更新，更新交车时间，增修内容。</p>
        <p>21、维修公司现场第一负责人把维修工单派工给维修技师，维修技师接受维修工单。</p>
        <p>22、维修技师准备增修项目所要用到的工具包括专用工具，把准备好的工具整齐的放在维修工位工具车上。</p>
        <p>23、维修技师拿着领料单到仓库领料窗口领取配件，领取的配件放在维修工位的工具车架子上。</p>
        <p>24、维修技师将维修工单，相应的维修项目打卡开始时间。</p>
        <p>25、维修技师进行维修作业，同时维修公司现场第一负责人对作业人员进行实时巡查管控。</p>
        <p>26、维修技师在完成维修项目时，对自己的维修项目进行自检。</p>
        <p>27、维修公司现场第一负责人对维修技师所有的维修项目进行终检，确保报修的故障得到解决，减少车辆的返厂率。</p>
        <p>28、维修技师拿着维修工单到打卡机，打卡相应的维修项目结束时间。</p>
        <p>29、维修技师把维修工单交给维修公司现场第一负责人。</p>
        <p>30、维修公司现场第一负责人把车辆开出车间，并试车，各项功能是否正常，</p>
        <p>同时维修技师把维修使用的工具整理好，归还到原来的位置。</p>
        <p>31、维修公司现场第一负责人对看板进行更新，在已离场处打√，并把看板挪到最下面，同时维修技师把剩余的配件归还库房。</p>
        <p>32、维修公司现场第一负责人把完工的维修工单交给客服，同时维修技师把维修工位清洁干净。</p>
        <p>33、客服接收维修公司现场第一负责人的完工维修工单。</p>
        <p>备注：维保作业标准必须依照员工手册第八章第三条《维保作业切块工艺管理规范》执行。</p>
        <p>考核：相应岗位未按流程执行的，每项考核20分；</p>
        <h3 name="0-6-0-2" className="point" id="0-6-0-2">3、车间维护保养作业标准</h3>
        <p>内容同第八章 维护保养作业切块工艺管理规范</p>
        <h3 name="0-6-0-3" className="point" id="0-6-0-3">4、师徒制管理细则</h3>
        <h4 name="0-6-0-3-0" className="point" id="0-6-0-3-0">4.1师徒身份的标准</h4>
        <h4>师傅的标准</h4>
        <p>1、必须取得云豪智慧学院颁发的相关证书；</p>
        <p>2、有厂家颁发的相应技术证书者优先选拔；</p>
        <p>3、在本部门拥有积分数较高者优先选拔；</p>
        <p>4、在维修岗位3年工龄以上者优先选拔；</p>
        <p>5、遵守公司各项规章制度，必须认可公司的企业文化；</p>
        <p>6、师傅必须熟知云豪集团《员工手册》，并向徒弟宣讲《员工手册》。</p>
        <p>徒弟的标准：</p>
        <p>1、入职审核后的实习期或试用期（不含行业从业经验者）且从事维修岗位的员工；</p>
        <h4 name="0-6-0-3-1" className="point" id="0-6-0-3-1">4.2师徒关系的确定</h4>
        <p>1、拜师仪式：相应部门全员参加，徒弟向师傅进行拜师环节（敬茶等），并照相留存至统计</p>
        <p>2、徒弟人数限制：每位师傅带徒弟人数上限为3人，徒弟在同一时间段只能跟随1位师傅。（出师后的徒弟不计入）；</p>
        <p>3、师徒关系的确定，师徒双方自愿选择签署《师徒协议》，最终人事安排由部门负责人或总监决定；</p>
        <p>4、师徒关系确定后，需报人力资源部备案。</p>
        <h4 name="0-6-0-3-2" className="point" id="0-6-0-3-2">4.3师傅的责任与权利</h4>
        <h4>责任</h4>
        <p>1、制定合理有效的学习计划及工作计划，帮助徒弟熟悉企业文化、规章制度岗位责任；</p>
        <p>2、从安全，思想、工作、生活上方方面面关注及关心徒弟；</p>
        <p>3、在规定时间内，师傅传授徒弟专项技能，直到帮助徒弟取得云豪智慧学院颁发的该专项技能证书。徒弟获取证书后即为在该专项技能领域出徒。</p>
        <p>4、师傅向徒弟宣讲云豪集团《员工手册》，并令其完全了解。</p>
        <h4>权力</h4>
        <p>师傅在工作中，积极鼓励徒弟并在积分考评中给予评定；</p>                                             <p>2、对于在学徒期间，如遇徒弟犯错屡教不改、德行品质差，可以上报直属领导，并决定是否录用；</p>
        <p>3、对于表现良好、吃苦耐劳，具有较强的上进心，规定时间内上报部门总监，做绩效考核并进行岗位调整。</p>
        <h4>考核</h4>
        <p>师傅每收一位徒弟，每月奖励补贴100分；若6个月之内，对应专项切块技术仍不能通过云豪学院考核，则考核200分，同时取消既发补贴。</p>
        <h4 name="0-6-0-3-3" className="point" id="0-6-0-3-3">4.4徒弟的责任及权利</h4>
        <h4>责任</h4>
        <p>1、严格遵守企业规章制度，做好本职工作、有吃苦耐劳的精神。</p>
        <p>2、在学习汇总，服从师傅安排的工作并有自己独立的观点。</p>
        <p>3、熟悉工作流程，遇到比较难的问题，虚心请教且记录到笔记上，运用到实际工作中。加强理论知识与实践的相结合。</p>
        <h4>考核</h4>
        <p>如果徒弟被2位以上师傅解除师徒关系，则公司将对徒弟解除劳动关系。</p>
        <h4>权利</h4>
        <p>1、师徒协议中监督机制可接受徒弟举报师傅的违规行为、故意刁难行为，发现师傅制作的学习计划及培养目标无效或者不合理，可向监督机制提出。</p>
        <p>备注：师傅与徒弟有双向选择的权利。</p>
        <h3 name="0-6-0-4" className="point" id="0-6-0-4">5、配件库房管理制度</h3>
        <p>每天检查货物信息，如发现储位不对、帐物不符、品质问题必须第一时间查明原因，向上级主管领导反馈和处理。</p>
        <p>1、配件入库，库房人员必须根据配件清单（订单、计划单、调入单）等单据，核查到货清单与实物品种、数量、型号及包装信息是否一致，状态是否完好等，必须在到货当天入库，遵循先入库后出库原则。</p>
        <p>2、配件出库必须凭派工单按照先进后出的原则发货，库房管理人员必须遵守以旧领新的规定。库房人员和领料人必须在配件出库单签字确认。</p>
        <p>3、配件出库必须第一时间打印，出库单不许丢失。</p>
        <p>4、配件借用：外出救援或在维修过程中借用的配件，在外出救援完毕或维修完毕后，库房人员要第一时间跟踪结算收费情况，车间借用配件的如果最终确定使用，要立即通知前台办理维修项目增加，与客户确认后，第一时间由库房办理出库，如果不使用要立即退回库房（保证配件完好），无论何种借用，库房都应建立配件借用登记表，由库房和借用人员签字。</p>
        <p>5、库房进行明确的区域划分，根据配件种类分类存放，有明确的货架和货物标签。</p>
        <p>6、库房禁止无关人员擅自进入，严禁烟火，防水、防盗。</p>
        <p>7、库房做好环境卫生保持工作，做到清洁、整齐、标志明显、过道畅通等。</p>
        <p>8、库房内不允许存放与配件无关的物品和替他人保管任何配件。</p>
        <p>9、货物的品质维护：物料在收货、点数、入库、搬运、摆放、归位、存放、储存、发货过程中遵守安全原则，做到防损、防水、防蛀、防晒等安全措施。</p>
        <p>考核：操作者必须按要求操作，违反者考核当事人100分/次，</p>
        <h2 name="0-6-1" className="point" id="0-6-1">二、专用条款</h2>
        <h3 name="0-6-1-0" className="point" id="0-6-1-0">1、卡车业务管理公司</h3>
        <h4 name="0-6-1-0-0" className="point" id="0-6-1-0-0">1.1 内部运转流程</h4>
        <h4 name="0-6-1-0-0-0" className="point" id="0-6-1-0-0-0">1.1.1 客户预约</h4>
        <p>1.1 客户直接向服务销售科预约</p>
        <p>1.1.1 业务人员将客户姓名、联系电话直接转给服务顾问，由服务顾问直接与客户联系商定预约服务。</p>
        <p>1.1.2 服务顾问将与客户商定的结果，在本部门内部群内进行反馈，以便业务人员掌握、了解服务预约结果。</p>
        <p>1.2 客户直接向服务顾问/站内接待人员预约</p>
        <p> 站内接待人员：首先了解客户车辆预约的事项，根据预约的事项、进厂时间提前准备接车单、领料单、保养检查表（刹车气路测试表）、执行DCS项目（预约看板更新、远程诊断、零件预提、人员安排）。</p>
        <h4 name="0-6-1-0-0-1" className="point" id="0-6-1-0-0-1">1.1.2服务顾问</h4>
        <p>2.1 随时向业务人员告知车辆维修进度及维修状况，完工时间。</p>
        <p>2.2 根据客户性质不同，维修过程中发现新增维修事件需报价时，先由服务顾问与业务人员内部沟通报价注意事项，由业务人员与客户直接沟通。</p>
        <p>2.3 针对客户提出的需求，对客户车辆做好相关维修记录（如轮保、发电机碳刷、京东保障等）避免重复执行或遗漏执行。</p>
        <p>2.4 每月二十日提供维修结算清单及明细（制定日期需要发票的客户另行提交）。</p>
        <h4 name="0-6-1-0-0-2" className="point" id="0-6-1-0-0-2">1.1.3 服务顾问：站内维修接待</h4>
        <p>3.1 站内进厂维修车辆的接待，礼貌接待客户，在委托修理单上记录客户报修的内容，记录车辆信息，放置座椅护套、脚垫；引导客户并与客户一起执行环车预检(记录车辆进厂时的外观情况，燃油液位、告知驾驶员整理和保管好驾驶室内的贵重物品)、询问客户维修车辆换下的旧零件处理方式以及客户的预想提车时间。</p>
        <p>3.2 完成接车后，将提前做好的维修预报价向客户解释一下，并获得客户的签字。然后将接车单、委托修理单、等一并转交给维修公司经理，引导客户进入休息区。告知可以移驾车辆至车间内预定工位。</p>
        <p>3.3 服务顾问，应适时了解所接待车辆的维修进度和了解是否有新增的维修项目，及时告知客户和进行沟通。</p>
        <p>3.4 服务顾问，应在维修后的七日内，对客户车辆进行维修质量回访。有问题的及时向上级领导汇报，获取新的处理意见。</p>
        <h4 name="0-6-1-0-0-3" className="point" id="0-6-1-0-0-3">1.1.4 服务顾问：站外维修预约</h4>
        <p>4.1 服务顾问在接到需要站外救援的客户，在了解车辆故障、救援地点、确定需要的预估零件后（必要时向维修公司经理获取支持），出具一个预估维修报价单，在与客户确认完维修价格、付款方式后，方可协调维修公司人员安排外出救援。</p>
        <p>4.2 服务顾问应随时了解外出救援事件的进度和状态，随时对外出救援人员给予各种支持。</p>
        <p>4.3 服务顾问应对外出救援回来的单据及时收单和出具腾鹰单据</p>
        <h4 name="0-6-1-0-0-4" className="point" id="0-6-1-0-0-4">1.1.5 生产车间</h4>
        <p>5.1 维修公司经理在移驾车辆后，及时跟新“车间维修进度看板”，</p>
        <p>维修公司经理对维修车辆的进度、过程应实时监督（作业环境的安全、效率、质量）。</p>
        <p>5.2 维修技师按照派工单进行库房领取配件、开始维修作业，对维修过程出现的新增需要维修事宜，由维修班组与接车服务顾问进行沟通。</p>
        <p>5.3 对于新增加的维修项目，由服务顾问在腾鹰系统的原工单上添加用料明细后，库房管理员可按照添加的用料明细给维修班组进行用料领用。</p>
        <p>5.4 维修技师在完成车辆维修作业后，核对接车单上的报修内容是否全部完成；并逐项填写维修结果。</p>
        <p>5.5 维修班组在完成维修作业后，呼叫维修公司经理进行作业完工质检。并在接车单中的质检处，进行签字确认。</p>
        <p>5.6 维修公司经理将质检签字后的单据交给服务顾问，办理结算出单。</p>
        <h4 name="0-6-1-0-0-5" className="point" id="0-6-1-0-0-5">1.1.6 服务顾问</h4>
        <p>6.1 服务顾问再次核对客户报修的内容车间是否逐一完成维修，未完成修复的要落实到原因，并向客户解释说明。</p>
        <p>6.2 服务顾问按照接车单内容和真实使用的零件，对客户出具最终的结算单据。</p>
        <p>6.3 维修类别属于三包服务性质的，只需客户在手写的服务记录单上完成签字即可；同时，将结算单据转交给索赔部门，进行向厂家申报费用。</p>
        <p>6.4 维修类别属于有偿服务性质的，客户在结算单完成签字后，还需缴纳维修费后，方可离场。</p>
        <h4 name="0-6-1-0-1" className="point" id="0-6-1-0-1">1.2 三包索赔业务及相关工作要求</h4>
        <h4 name="0-6-1-0-1-0" className="point" id="0-6-1-0-1-0">1.2.1 服务顾问-索赔部</h4>
        <p>1.1 服务顾问在办理三包业务前，务必先于索赔部进行确认、商议后，方可按照索赔业务流程执行。</p>
        <p>1.2 服务顾问在向客户办理完索赔业务后，要将当次客户签字单据交给索赔部。</p>
        <p>1.3 办理零件索赔的，除了当次客户签字单据外，还需提供上一次维修单据。</p>
        <p>1.4 索赔部门负责向前台部门提供有关原厂下发的专案类索赔维修所涉及到的用户和车辆明细清单，前台部门负责预约、联系专案类涉及到的客户，并安排维修班组完成维修。</p>
        <h4 name="0-6-1-0-1-1" className="point" id="0-6-1-0-1-2">1.2.2 维修公司-索赔部</h4>
        <p>2.1 维修技师必须具备零件损坏原因的分析能力（人为原因损坏和正常使用出现的损坏）。</p>
        <p>2.2 维修技师现场的分析情况，必须告知索赔主管；对于索赔产生质疑的因素，索赔部可先于服务顾问沟通，最后由服务顾问（客户对接的业务经理）与客户进行对接沟通。</p>
        <p>2.3 维修技师提供完整的故障分析单据，损坏零件的照片（能反映出故障点的照片，比如燃油箱漏油），新旧零件的对比照，安装新件后的照片。照片统一发送至本部门索赔群内。</p>
        <p>2.4 索赔电子部件（如尿素系统配量阀、电脑模块）等，需要提供车辆行驶数据，并上传至sail网站里。</p>
        <p>2.5 外出维修后的单据，在回到场内后先交给服务顾问，由服务顾问完成系统内部等级、关单后，交给索赔部，由索赔部向厂家办理费用申报。</p>
        <p>2.6 技师可以协助索赔主管，一并对Fras的问题进行回复。</p>
        <h4 name="0-6-1-0-1-2" className="point" id="0-6-1-0-1-2">1.2.3 索赔部-零件仓储</h4>
        <p>3.1 索赔部按照原厂下发的技术专案、技术改进信息中涉及到的零件，报给零件仓储配件部做零件储备计划，并完成零件订购。</p>
        <p>3.2 索赔部再得到一些新改进的专用工具通知后，与维修公司经理商议、一并出具专用工具采购申请，报至服务经理处审核，品牌总监审批后，零件部负责工具订购。</p>
        <p>3.3 对于新车到岗差异零件、索赔用件的领用和出库；索赔部在接到此类业务需求后，在腾鹰系统内打印零件出库单，库房管理员按照此单内容进行零件领用至需要方，完成零件领用后并在单据内进行签字；此时，单据直接转交给怀远出单人员，按照零件成本价当天内完成零件的怀远出单。</p>
        <h4 name="0-6-1-0-2" className="point" id="0-6-1-0-2">1.3 车间生产管理</h4>
        <p>1、全体员工必须廉洁奉公，严禁索贿、受贿，以及私自收款，违反规定给予考核500-1000分/次，直至除名。</p>
        <p>2、待修车、完工车、进厂车由维修公司经理或维修公司经理指定人员挪动车辆，未经维修公司经理批准，私自挪动车辆的发现给予考核100分/次，车辆出现任何事故由当事人负全部责任。</p>
        <p>3、非工作需要不得动用任何车辆，在站内行驶速度不能超过5km/h，不准在站内试验刹车，如有违反给予考核100分/次。</p>
        <p>4、洽谈修车业务是服务顾问的工作，除工作需要外，维修公司员工一律不得私下与客户洽谈，如有技术或其他问题需与客户商谈应先由接待人员或各部门主管先行联系在进行配合，违反者给予考核100分/次。</p>
        <p>5、车辆驶入车间后严格按照委托书上项目进行施工，如发现维修人员在没有通知服务顾问的的情况下私自给客户进行増项并维修的、以及没有委托书将车开入车间维修的，考核100分/次。</p>
        <p>6、维修人员在完成维修后上交单据（接车单、保养检查表），如发现单据没填写完整，当事人考核20分/次，内应该做的项目未做的，发现考核20分/次。</p>
        <p>7、在维修作业过程中，因个人行为造成延迟交车对客户不礼貌、言语攻击，造成客户投诉的，考核200分/次。</p>
        <p>8、违规操作设备、专用工具的考核50分/次；损坏的专用工具由当事人承担全部责任个工具采购费用，对设备、人员造成严重后果的，视情节严重情况对操作员、维修公司经理、及相关负责人做出相应处罚。</p>
        <p>9、维修公司经理应带头做到并督促维修技师对进入工位维修的车辆做好卫生防护工作，严格做到工具、配件、油品不落地；违反处罚：从该技师当月提成中考核，50分/次。</p>
        <p>10、维修公司经理负责督促维修技师对维修工位在作业过程中，所滴漏下来的油水等脏物进行清洁，在维修作业完工后应对维修工位及时进行清洁打扫，以及工具的清洁摆放；违反处罚，从该维修人员当月绩效中考核50分/次。</p>
        <p>11、维修技师应在完工后，或下班前做好本工段卫生区域的清洁清扫工作，并对本工段零件小车上的零碎杂物等进行清除整理，违反处罚，从该技师当月绩效中考核50分/次。</p>
        <p>12、维修技师完成车辆维修工作，在维修技师自检合格后，应及时交至维修公司经理进行终检，终检确认所有维修项目，完工合格时，再交付服务顾问。 违反处罚：因本次班维修技师未做好交接工作，造成车辆维修延误的，从当事主修技师当月绩效中考核50分/次。</p>
        <p>13、不许夹带公司物品出厂，门卫有权检查，一经发现立即开除，严重的送至公安机关。</p>
        <p>14、下班后务必要做到断电、断水，杜绝不必要的安全隐患。</p>
        <h4 name="0-6-1-0-3" className="point" id="0-6-1-0-3">1.4 卡车公司生产管理各项表格模板</h4>
        <h3 name="0-6-1-1" className="point" id="0-6-1-1">2、云豪车服车间管理细则</h3>
        <h4 name="0-6-1-1-0" className="point" id="0-6-1-1-0">2.1 关于法士特/欧辉/欧曼/重汽的服务管理办法</h4>
        <h4 name="0-6-1-1-0-0" className="point" id="0-6-1-1-0">2.1.1 关于法士特索赔要求</h4>
        <p>1、救援派工响应率：</p>
        <p>（1）：索赔科或客户服务科接到法士特派工15分钟内响应（与客户联系）当事人失职考核50分/次;</p>
        <p>（2）： 客户服务科接到索赔科法士特派工应快速反馈维修公司落实（5分钟内出结果）当事人失职考核50分/次;</p>
        <p>（3）：维修公司收到法士特派工应积极配合处理（5分钟内回复）,维修公司人员不足情况下要与客户良好的沟通达成一致次日安排维修不了的推诿400或其它维修站进行维修；</p>
        <p>2、客户回访合格率：</p>
        <p>索赔科收到关闭工单前应对客户100%进行电话回访（服务满意度、服务及时性、故障是否解决处理等）；当事人失职考核50分/次;</p>
        <p>3、报单及时率：</p>
        <p>（1）：维修公司索赔科法士特单据完工后：站内6小时内与服务科交接照片，站外12小时内与服务科交接照片;当事人失职考核50分/次;</p>
        <p>（2）：索赔科紧盯服务全过程，及时交接照片，24小时内系统完成报单，当事人失职考核100分/次;</p>
        <p>4、故障件合格率：</p>
        <p>每月旧件返还严格按照法士特要求，对所换旧件不确定是否损坏的应进行询问维修公司进行判断（维修公司协助配合）旧件入库，必须有索赔人员在场，当事人失职考核50分/次。</p>
        <p>5、报单准确率：</p>
        <p>（1）索赔科提升索赔专员的技能以及熟知法士特的服务政策，对维修服务车辆信息及时查看，提高索赔报单一次性成功率，避免由于自身不严谨多次提报服务单；当事人失职考核50分/次；</p>
        <p>（2）照片不合格的原因多为：不认真、相片模糊、漏拍、确认单无合影，维修公司严格按照法士特照片要求拍摄，总结前期经验，当事人失职考核50分/次。</p>
        <p>索赔科根据维修人员政策掌握情况定期组织培训。</p>
        <p>维修公司所拍的内容必须清晰可见，不可以模糊不清。出现模糊不清楚的由当事人对此单负全部责任。</p>

        <h4 name="0-6-1-1-0-1" className="point" id="0-6-1-1-0-1">2.1.2 欧辉服务要求</h4>
        <p>1、救援派工响应率：</p>
        <p>（1）：索赔科或客户服务科接到欧辉派工15分钟内与客户联系；当事人失职考核50分/次;</p>
        <p>（2）： 客户服务科接到索赔科派工应快速反馈维修公司落实（5分钟内出结果）当事人失职考核50分/次;</p>
        <p>（3）：维修公司收到欧辉派工应积极配合处理（5分钟内回复）,维修公司人员不足情况下要与车队技术队长良好的沟通达成一致次日安排维修；</p>
        <p>2、客户回访合格率：</p>
        <p>索赔科提报索赔单前应对客户100%进行电话回访（服务满意度、服务及时性、故障是否解决处理等）；当事人失职考核50分/次;</p>
        <p>3、报单及时率：</p>
        <p>（1）维修公司索赔科欧辉单据完工后：站内6小时内与服务科交接照片，站外12小时内交接照片;当事人失职考核50分/次;</p>
        <p>（2）索赔科紧盯服务全过程，及时交接照片，24小时内系统完成报单，当事人失职考核100分/次;</p>
        <p>4、故障件合格率：</p>
        <p>每月旧件返还严格按照欧辉要求，对所换旧件不确定是否损坏的应进行询问维修公司进行判断（维修公司协助配合）旧件入库，必须有索赔人员在场，当事人失职考核50分/次。</p>
        <p>5.报单准确率：</p>
        <p>（1）索赔科提升索赔专员的技能以及熟知欧辉的服务政策，对维修服务车辆信息及时查看，提高索赔报单一次性成功率，避免由于自身不严谨多次提报服务单；当事人失职考核50分/次；</p>
        <p>（2）照片不合格的原因多为：不认真、相片模糊、漏拍、确认单无合影，维修公司严格按照欧辉照片要求拍摄，总结以上经验，当事人失职考核50积分/次。</p>
        <p>索赔科根据维修人员政策掌握情况定期组织培训。</p>
        <p>维修公司所拍的内容必须清晰可见，不可以模糊不清。出现模糊不清楚的由当事人对此单负全部责任。</p>

        <h4 name="0-6-1-1-0-2" className="point" id="0-6-1-1-0-2">2.1.3 欧曼服务要求</h4>
        <p>1、救援派工响应率：</p>
        <p>（1）： 索赔科或客户服务科接到欧曼派工15分钟内响应（与客户联系）当事人失职考核50分/次。</p>
        <p>（2）：索赔科15分钟内落实情况进行系统操作（与维修公司、客户挂单待处服务科、配件科、客户）接收或其它情况进行处理，禁止系统长时间未受理状态。当事人失职考核50分/次。</p>
        <p>（3）：客户服务科接到索赔科欧曼派工应快速反馈维修公司落实（5分钟内出结果）当事人失职考核50分/次。</p>
        <p>（4）：维修公司收到欧曼派工应积极配合处理（5分钟内回复）,维修公司人员不足情况下要与客户良好的沟通达成一致次日安排维修不的推诿400或其它维修站进行维修。</p>
        <p>（5）：维修人员派工关闭：工单开始至结束不得超过24小时，如有调件或大修（发动机等），24小时无法完成，需向400反馈，避免造成考核，当事人失职考核50分/次。</p>
        <p>（6）：索赔科负责紧盯整个服务流程及处理结果；</p>
        <p>备注：15分钟内由派工页面联系用户，维修公司人员关闭工单时需电话通知索赔科，特殊情况及时告知索赔科人员备案。当事人失职考核50分/次。</p>
        <p>2、客户回访合格率：索赔科收到关闭工单前应对客户100%进行电话回访（服务满意度、服务及时性、故障是否解决处理等）；当事人失职考核50分/次。</p>
        <p>3、报单及时率：索赔科欧曼单据完工后24小时内系统必须填报；当事人失职考核100分/次。</p>
        <p>4、故障件合格率：每月旧件返还严格按照欧曼要求，对所换旧件不确定是否损坏的应进行询问维修公司进行判断（维修公司协助配合）旧件入库，必须有索赔人员在场，当事人失职考核50分/次。</p>
        <p>5、报单准确率：索赔科提升索赔专员的技能以及熟知欧曼的服务政策，对维修服务车辆信息及时查看，提高索赔报单一次性成功率，避免由于自身不严谨多次提报服务单；当事人失职考核50分/次。</p>
        <p>索赔科根据维修人员政策掌握情况定期组织培训。</p>
        <p>维修公司所拍的内容必须清晰可见，不可以模糊不清。出现模糊不清楚的由当事人对此单负全部责任。</p>

        <h4 name="0-6-1-1-0-3" className="point" id="0-6-1-1-0-3">2.1.4 关于重汽服务要求</h4>
        <p>1、救援派工响应率：</p>
        <p>（1）：索赔科或客户服务科接到重汽派工15分钟内响应（与客户联系）当事人失职考核50分/次;</p>
        <p>（2）： 客户服务科接到索赔科重汽派工应快速反馈维修公司落实（5分钟内出结果）当事人失职考核50分/次;</p>
        <p>（3）：维修公司收到法重汽派工应积极配合处理（5分钟内回复）,维修公司人员不足情况下要与客户良好的沟通达成一致次日安排维修不了的推诿400或其它维修站进行维修；</p>
        <p>2、客户回访合格率：</p>
        <p>索赔科收到关闭工单前应对客户100%进行电话回访（服务满意度、服务及时性、故障是否解决处理等）；当事人失职考核50分/次;</p>
        <p>3、报单及时率：索赔科重汽单据完工后24小时内系统必须填报；当事人失职考核100分/次。</p>
        <p>4、故障件合格率：</p>
        <p>每月旧件返还严格按照重汽要求，对所换旧件不确定是否损坏的应进行询问维修公司进行判断（维修公司协助配合）旧件入库，必须有索赔人员在场，当事人失职考核50分/次。</p>
        <p>5、报单准确率：</p>
        <p>索赔科提升索赔专员的技能以及熟知重汽的服务政策，提高索赔报单一次性成功率，避免由于自身不严谨多次提报服务单；当事人失职考核50分/次。</p>
        <p>索赔科根据维修人员政策掌握情况定期组织培训。</p>
        <p>维修公司所拍的内容必须清晰可见，不可以模糊不清。出现模糊不清楚的由当事人对此单负全部责任。</p>
        <h4 name="0-6-1-1-1" className="point" id="0-6-1-1-1">2.2 陕汽/潍柴工时系数服务要求</h4>
        <h4 name="0-6-1-1-1-0" className="point" id="0-6-1-1-1-0">2.2.1 陕汽工时系数服务要求</h4>
        <h4>保修服务工时费=（单价费用（激励系数*工时单价+政策激励单价+工时单价+星级单价+人员激励单价+评价激励单价）*维修工时（维修工时+二类工时总合）+区域补助（高寒区域补助+特殊区域补助））*工时倍数+延时补偿费用+其他费用</h4>
        <h4>注：工时激励系数+评价激励系数+政策激励系数最高不超过 0.5（康明斯车型最高不超过 0.7）</h4>
        <p><strong>（一）响应：</strong> 3分钟内联系用户核实车辆和故障信息，同时于15分钟内在陕重汽营销管理平台（渠道售后-索赔单管理-工单管理-派工执行单）确认服务，当事人失职考核50分/次。</p>
        <p><strong>（二）外出：</strong>1、外出服务时要求接受派工后 1 小时内出发，索赔科15分钟内落实情况进行系统操作（与维修公司、客户服务科、配件科、客户）接收或其它情况进行处理，禁止系统长时间挂单待处理状态。当事人失职考核50分/次。</p>
        <p>2、客户服务科接到索赔科潍柴派工应快速反馈维修公司落实（5分钟内出结果）当事人失职考核50分/次。</p>
        <p>3、维修公司收到陕汽派工应积极配合处理（5分钟内回复）,维修公司人员不足情况下要与客户良好的沟通达成一致。当事人失职考核50分/次。</p>
        <p><strong>（三）到达：</strong>距离服务站 50 公里以内，2 小时内到达现场；200 公里以内，6 小时内到达现场；偏远地区 12 小时内到达现场，主修人员到达故障现场后，在陕汽互联手机客户端软件上点击“到达”并上传照片；</p>
        <p><strong>（四）完工：</strong></p>
        <p>售前检查、保养类服务需在 4 小时内完工，</p>
        <p>快运车辆服务需在 12 小时内完工，一般故障 24 小时内完工，</p>
        <p>疑难及总成大修类服务要求 72 小时内完工；</p>
        <p>陕汽互联手机客户端“工单维护”模块点击“完成”。</p>
        <p>相关索赔专员在每天下班前检查工单关闭情况，当事人失职考核50分/次。</p>
        <p>评价：</p>
        <p>①完工短信评价：服务站APP点击“完成”后，系统会自动发评价短信至用户手机，特约服务站主动邀请客户对本次服务进行满意度评价。②e 随行客户端评价：特约服务站点击“完成”后，用户可进行评价。③人工客服回访评价：呼叫中心对索赔报单中的客户信息、维修信息真实性及客户满意度三方面进行 100%回访。</p>
        <p>要求服务确认单要在现场填写并上传完工，维修师傅要在现场引导客户完成工单评价。当事人失职考核200分/次。</p>
        <p><strong>（五）陕汽系统工时系数计算规则</strong></p>
        <p>（1）报修 15 分钟响应(服务站响应时间-派工时间≤15 分钟) --- 考核20分</p>
        <p>（2）外出 1 小时出发（实际出发时间-响应时间≤1 小时）---考核30分</p>
        <p>（3）服务承诺外出到达（到达时间-出发时间≤按照服务承诺执行）---占15分</p>
        <p>（4）分故障报修闭环（完成时间-响应时间≤4/12/24/72 小时）---占35分</p>
        <p>某站（一般区域）本月15分钟响应率：98%，1小时外出率：89%，服务承诺到达率：90%，闭环率：87%</p>
        <p>服务站服务及时性指标：98%*20%+89%*30%+90%*15%+87%*35%=90.2%</p>
        <p>一份外出救援报单（总分100）：</p>
        <p>1.未15分响应，扣20分；</p>
        <p>2.未1小时出发，扣30分；</p>
        <p>3.未按时限到达，扣15分；</p>
        <p>4.未按时限完工，扣35分；</p>
        <p>保修服务工时费=（单价费用（激励系数*工时单价+政策激励单价+工时单价+星级单价+人员激励单价+评价激励单价）*维修工时（维修工时+二类工时总合）+区域补助（高寒区域补助+特殊区域补助））*工时倍数+延时补偿费用+其他费用</p>
        <p><strong>出发类：</strong>服务车与服务站门头合影照片、服务车辆照片、服务车里程表照片（看清楚数字）；</p>
        <p><strong>到达类：</strong>服务车与故障车合影照片、服务车里程表照片（看清楚里程数字）、用户收礼品和车辆合影照片；</p>
        <p>维修类：整车照片（整车左/右前方45°角，突出周围环境；外出拍摄服务车和故障车合影照片）、里程表照片（必须看清里程表数字）、车辆铭牌照片（必须看清楚数字）</p>
        <p><strong>完工类：</strong>故障件拆前照片（近景、远景照片各1张，需体现损坏部位及周围环境）、拆装检修过程照片（近景、远景照片各1张，需体现损坏部位及周围环境）、修复后照片（故障修复后照片1张，需体现损坏部位及周围环境）、服务记录单照片（维修完毕，写好服务单找司机签字，关闭工单并提醒司机手机短信给予评价）；</p>
        <h4>注意：</h4>
        <p>站内服务拍摄（维修类、完工类），外出服务（出发类、到达类、维修类、完工类）；</p>
        <p>汉德桥报单时，必须填报配件新、旧件批次号；</p>
        <p>变速箱、发动机、车桥、气瓶及附件维修需传名牌照片；</p>
        <h4 name="0-6-1-1-1-1" className="point" id="0-6-1-1-1-1">2.2.2 潍柴工时系数要求</h4>
        <p>为保证拿到潍柴的最高工时费系数（1.7）特制定此要求：</p>
        <p>工时系数计算方式 K=K1XK2XK3XK4XK5</p>
        <p>即:K=最终工时系数 K1=派工关闭率 K2=客户回访合格率 K3=报单及时率   K4=故障件合格率 K5=报单准确率 </p>
        <p>1、 K1派工关闭率：</p>
        <p>A：索赔科或客户服务科接到潍柴派工15分钟内响应（与客户联系）当事人失职考核50分/次。</p>
        <p>B：索赔科15分钟内落实情况进行系统操作（与维修公司、客户服务科、配件科、客户）接收或其它情况进行处理，禁止系统长时间挂单待处理状态。当事人失职考核50分/次。</p>
        <p>C：客户服务科接到索赔科潍柴派工应快速反馈维修公司落实（5分钟内出结果）当事人失职考核50分/次。</p>
        <p>D：维修公司收到潍柴派工应积极配合处理（5分钟内回复）,维修公司人员不足情况下要与客户良好的沟通达成一致次日安排维修不的推诿400或其它维修站进行维修；</p>
        <p>E：维修人员派工关闭：小修不得低于40分钟，不得超过24小时。中修不超48小时。大修不超72小时(更换整机的另议）当事人失职考核50分/次。</p>
        <p>备案：索赔科负责根据实际情况备案；服务站原因没人没车不许备案(调三包加急配件可以备案，需要提供调件单号)，用户原因给备案。必须保证所备案的单据后期申诉全部合格！</p>
        <p>F：索赔科负责紧盯整个服务流程及处理结果；</p>
        <p>备注：禁止接收工单后40分钟内完工关闭工单，维修公司人员关闭工单时需电话通知索赔科；维修人员保养、维修换件必须指导客户注册100%红包扫码（特殊情况通知索赔科备案）当事人失职考核50分/次。</p>
        <p>2、K2客户回访合格率：索赔科收到关闭工单前应对客户100%进行电话回访（服务满意度、服务及时性、故障是否解决处理等）；当事人失职考核50分/次。</p>
        <p>3、K3报单及时率：索赔科潍柴单据完工后24小时内系统必须填报；当事人失职考核100积分/次</p>
        <p>4、K4故障件合格率：每月旧件返还严格按照潍柴要求，对所换旧件不确定是否损坏的应进行询问维修公司进行判断（维修公司协助配合）当事人失职考核50分/次。</p>
        <p>5、K5报单准确率：索赔科提升索赔专员的技能以及熟知潍柴的服务政策，提高索赔报单一次性成功率，避免由于自身不严谨多次提报服务单；当事人失职考核50分/次。</p>
        <p>索赔科根据维修人员政策掌握情况定期组织培训。</p>
        <p>云豪车服管理公司全体人员都要重视必须保证潍柴系数1.7</p>
        <h4 name="0-6-1-1-2" className="point" id="0-6-1-1-2">2.3 云豪车服对内/对外收费工时标准</h4>
        <h4>附件：云豪车服对内对外收费工时标准</h4>
        <h4 name="0-6-1-1-3" className="point" id="0-6-1-1-3">2.4 云豪车服服务承诺</h4>
        <p>1、严格按照机动车维修标准维修服务；</p>
        <p>2、严格遵守国家相关政策、法规和规章做好安全管理工作，确保维修质量；</p>
        <p>3、全天24小时值班为客户服务（24小时服务电话010-69134972）接到客户需求后第一时间安全、保质、保量、高效完成需求处理；</p>
        <p>4、严格执行机动车维修工时定额及单价，合理收费。严格执行机动车维修质量保证期制度；</p>
        <p>5、提供完整、规范、有效的机动车维修单证和票证，希望您在车辆维修期间对我单位承诺给予监督，</p>
        <p>如未按照以上承诺执行欢迎投诉举报，我单位投诉举报电话：15611901621</p>
        <h4 name="0-6-1-1-4" className="point" id="0-6-1-1-4">2.5 云豪车服生产管理各项表格模板</h4>
        <h3 name="0-6-1-2" className="point" id="0-6-1-2">3、客车业务管理公司生产车间管理细则</h3>
        <p>1、必须服从车间生产科的安排，尽职尽责做好本职工作，坚决反对故意刁难、疏忽或拒绝上级主管命令或工作分配。未按此标准执行的考核积分200分。</p>
        <p>2、必须遵守上下班作息时间，按时上下班（每日参加晨会前把工作服工作鞋穿好），如遇特殊情况需要加班时，服从车间生产科长安排。未按此标准执行的考核积分100分。</p>
        <p>3、现场人员在工作期间不得做与工作无关的事情，生产现场禁止吃食物、吸烟、看小说、报刊、聊天、嬉戏打闹、吵架；未按此标准执行的考核积分200分。</p>
        <p>4、必须按照操作流程严格执行，漏项或不按标准执行的考核积分200分。</p>
        <p>5、严格执行各项安全操作规程，员工必须时刻谨记，安全第一观念，时刻注意人身安全，设备安全，对于安全规定必须无条件服从。未按此标准执行的考核积分200分。</p>
        <p>6、车间现场地面应时刻保持清洁，维修完工后，及时清洁工位。未按此标准执行的考核积分100分。</p>
        <p>7、除车间技师、在生产车间玩耍或滥动设备、仪器，由此造成的事故自行承担，考核积分500分。</p>
        <p>8、任何人不得携带易燃易爆、毒品、浓气味等违禁品，危险品或与生产无关的物品进入车间。</p>
        <p>考核：予以辞退，并赔偿相应损失。</p>
        <p>9、所有进入车间的人员必须穿工作服，及工作鞋。（车间生产人员上班期间一直穿着工作服，工作鞋，无论有没有生产）未按此标准执行的考核积分200分。</p>
        <p>10、正确使用公司的仪器、设备，不得擅用非自己岗位的设备、检测等工具。未按此标准执行的考核积分200分。</p>
        <p>11、车间员工必须做到文明生产，积极完成生产任务，因工作需要临时抽调，服从安排协助用人部门的管理，对不服从安排者将上报部门监察部按规定进行处理。未按此标准执行的考核积分100分。</p>
        <p>12、所有的生产作业必须按照工厂手册进行。未按此标准执行的考核积分100分。</p>
        <p>13、严格执行各项安全操作规程，员工必须时刻谨记，安全第一观念，时刻注意人身安全，设备安全，对于安全规定必须无条件服从。未按此标准执行的考核积分500分。</p>
        <p>14、如一个月未违反以上作业流程的，相关人员奖励+200分；</p>
        <p>15、如全年未违反以上作业流程的奖励+800分；</p>
        <p>16、对车间管理提出合理化意见，经管理公司采纳+200分；</p>
        <p>17、对多人参与作业的维修项目，提供有效增加效率的方案，经管理公司采纳的+500分；多人共同提供方案的平均分配积分。</p>
        <p>18、及时上报或举报的重大隐患，经管理公司核实的奖励当事人+800分；有重大突出表现的由管理公司报集团决定奖励。</p>
        <h3 name="0-6-1-3" className="point" id="0-6-1-3">4、配件业务管理公司</h3>
        <h4 name="0-6-1-3-0" className="point" id="0-6-3-0">4.1仓储物流表格模板</h4>

    </div>
</div>;

export default Section$;